<template>
  <div v-if="instruction.file" class="product__instruction product-instruction">
    <a class="product-instruction__instruction" :href="instruction.file" target="_blank">
      <img src="/img/svgo/product-page/pdf.svg" alt="icon" />
      <span v-if="title">{{ title }}</span>
      <span v-else>
        {{ $t('instruction') }}
        <template v-if="hasSets">{{ $t('instruction_pretext') }} "{{ instruction.title }}"</template>
      </span>
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ProductInstruction',
  props: {
    instruction: {
      type: Object,
      required: true
    },
    title: String
  },
  computed: {
    ...mapState({
      hasSets: state => state.productInfo.productInfo.hasSets
    })
  }
}
</script>

<style scoped lang="sass">

.product-instruction
  & + &
    margin-top: 30px

.product-instruction__instruction
  display: flex
  align-items: flex-start
  width: 100%

  span
    margin-left: 10px
    color: $nd-link-color
    font-size: 14px
    line-height: 25px
    font-weight: 400
    text-decoration: underline
    text-underline-offset: 3px

  &:hover
    span
      text-decoration: none
</style>
